"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M4.55 14.5a1 1 0 1 0 0 2 1 1 0 1 0 0-2zm5 2.25a.75.75 0 0 0 0-1.5A1.25 1.25 0 0 1 8.3 14v-1a1.25 1.25 0 0 1 1.25-1.25.75.75 0 0 0 0-1.5A2.75 2.75 0 0 0 6.8 13v1a2.75 2.75 0 0 0 2.75 2.75Zm3.5 0A1.76 1.76 0 0 0 14.8 15v-3a1.75 1.75 0 0 0-3.5 0v3a1.75 1.75 0 0 0 1.75 1.75ZM12.8 12a.25.25 0 0 1 .5 0v3c0 .28-.5.28-.5 0Zm3.75 4.75a.76.76 0 0 0 .75-.75v-2.08a.07.07 0 0 1 0-.06s.05 0 .07 0a.78.78 0 0 0 1.28 0h.07a.07.07 0 0 1 0 .06V16a.75.75 0 0 0 1.5 0v-5a.74.74 0 0 0-.55-.72.75.75 0 0 0-.84.33l-.65 1.07a.23.23 0 0 1-.42 0l-.65-1.07a.75.75 0 0 0-.84-.33.74.74 0 0 0-.55.72v5a.76.76 0 0 0 .83.75Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M24 4.75a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v14.5a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3Zm-14.35-1a1 1 0 0 1 1.7 0 .91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 .91.91 0 0 1 0-1Zm-3.5 0a1 1 0 0 1 1.7 0 .91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 .91.91 0 0 1 0-1Zm-3.56.09a1 1 0 0 1 1.76-.09.91.91 0 0 1 0 1 1 1 0 0 1-1.7 0 1 1 0 0 1-.15-.5 1.12 1.12 0 0 1 .09-.41ZM22 19.25a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a.25.25 0 0 1 .25-.25h19.5A.25.25 0 0 1 22 7Z"
})), 'BrowserCom');

exports.default = _default;